import React from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import styles from './index.scss';
import { Text } from '@dropbox/dig-components/typography';

type EventLike = {
  target: {
    value: string;
  };
};
type props = {
  isMonthly?: boolean;
  isSwitchToAnnual?: boolean;
  onChange: (evt: EventLike) => void;
};

const IAgreeCheckbox: React.FunctionComponent<props> = ({
  onChange,
  isSwitchToAnnual,
}) => {
  const agreeLabelMessage = (
    <Text size="large">
      <FormattedMessage
        id=""
        description="'I agree' legal text for a payment form."
        defaultMessage="I agree to the <b>Automatic Renewal Terms</b> above."
        values={{
          /* eslint-disable react/display-name, react/jsx-no-target-blank */
          b: (...chunks: any[]) => <strong>{chunks}</strong>,
          /* eslint-enable react/display-name, react/jsx-no-target-blank */
        }}
      />
    </Text>
  );

  return (
    <div
      className={classNames(styles.switchBillingPeriodModalAgreeContainer, {
        [styles.marginTop]: !isSwitchToAnnual,
      })}
    >
      <input
        id="switchBillingPeriodModalAgreeCheckbox"
        type="checkbox"
        onChange={onChange}
      />
      <label
        className={styles.switchBillingPeriodModalAgreeLabel}
        htmlFor="switchBillingPeriodModalAgreeCheckbox"
      >
        {agreeLabelMessage}
      </label>
    </div>
  );
};

export default IAgreeCheckbox;
